import { render, staticRenderFns } from "./AgendamentoNotificationDropdown.vue?vue&type=template&id=3e45c816&scoped=true"
import script from "./AgendamentoNotificationDropdown.vue?vue&type=script&lang=js"
export * from "./AgendamentoNotificationDropdown.vue?vue&type=script&lang=js"
import style0 from "./AgendamentoNotificationDropdown.vue?vue&type=style&index=0&id=3e45c816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e45c816",
  null
  
)

export default component.exports